<template>
  <DialogLayout
    title="新規追加"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <CustomerMasterForm
        ref="customerForm"
        v-model="customerFormModel"
        label-width="10em"
        formMode="register"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-customer-name-set="autocompleteCustomerNameSet"
      />
    </template>
    <template #footer>
      <RegisterDialogFooter
        @clear="clickClear"
        @register="clickRegister"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import CustomerMasterForm from '@/components/organisms/dialog/master/CustomerMasterForm.vue'
import RegisterDialogFooter from '@/components/organisms/dialog/RegisterDialogFooter.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    CustomerMasterForm,
    RegisterDialogFooter
  },
  mixins: [
    CustomerAutocompleteLoader
  ],
  props: {
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerNameSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      customerFormModel: {
        customer_code: undefined,
        customer_name: undefined,
        private_id: undefined,
        invoice_address: undefined,
        postal_code: undefined,
        street_address: undefined,
        phone_number: undefined,
        owner_type: undefined,
        billing_day: undefined,
        transfer_day: undefined,
        invoice_type: undefined,
        // 20220516髙森追記
        billing_exclusion_falg: undefined,
        email_target: undefined
        // ここまで
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickClear () {
      this.$refs.customerForm.clearFields()
    },
    async clickRegister () {
      this.$loadingMask.on()

      // const params = { ...this.customerFormModel }
      // params.user_id = this.$session.get('login-user').userId

      this.$refs.customerForm.validate()
        .then((valid) => {
          return this.$axios.post('/customer', this.customerFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.margeCustomerCodeSet(this.customerFormModel.customer_code)
          this.margeCustomerNameSet(this.customerFormModel.customer_name)
          this.$emit('refresh')
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['customer_code', 'customer_name']
      this.$nextTick(() => {
        this.$refs.customerForm.clearFields()
        Object.keys(this.customerFormModel)
          .forEach((x) => {
            if (trimItem.includes(x) && this.currentRow[x]) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.customerFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
